module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABABAMAAABYR2ztAAAAGFBMVEUAAABVVVVRSkpPTU1OTU1OTU1OTU1OTU1DAJt2AAAAB3RSTlMABiaIre7xPraf7gAAAFFJREFUSMdjYBgFww4wuaUoMDAIh5fDQakhigLV8vIgBgbzciRQjKLAvby8hIEhHFlBKYqC9PLyMiIUELSCoCMJenM0NkdjczQ2R2NzFAwEAABVUo/X1eTHzAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/navigation/phone_ico_menu.png
// module id = MFvt
// module chunks = 0